import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Grid, Typography } from '@hbf/dsl';
import { SearchFiltersTooltip } from 'ha/pages/Search/components/SearchFilters/SearchFiltersTooltip';

const useStyles = makeStyles()(theme => ({
  label: {
    width: '100%',
  },
  countWrapper: {
    background: theme.palette.grey[100],
    borderRadius: '30px',
  },
  countLabel: {
    color: theme.palette.grey[600],
    paddingTop: theme.spacing(0.125),
    paddingBottom: theme.spacing(0.125),
    paddingRight: theme.spacing(1),
    paddingLeft: theme.spacing(1),
  },
}));

interface Props {
  title: string;
  count?: number;
  toolTip?: {
    text: string;
    analyticsName: string;
    title: string;
  };
}

export const CommonCheckboxTitleWithCount: React.FC<Props> = ({
  title,
  count,
  toolTip,
}) => {
  const { classes } = useStyles();

  return (
    <Grid
      container
      className={classes.label}
      justifyContent="space-between"
      alignItems="center"
      component="span"
    >
      <Grid item component="span">
        {title}
        {toolTip && (
          <SearchFiltersTooltip
            text={toolTip.text}
            title={toolTip.title}
            analyticsName={toolTip.analyticsName}
          />
        )}
      </Grid>
      {count !== undefined && (
        <Grid item component="span" className={classes.countWrapper}>
          <Typography.HelperText
            fontWeight="bold"
            component="span"
            className={classes.countLabel}
          >
            {count || 0}
          </Typography.HelperText>
        </Grid>
      )}
    </Grid>
  );
};
